export const AskForRightsPage = () => {
  return <p>Please ask administrators to give your account a role. Then sign out and sign in.</p>;
};
